import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { cva } from 'class-variance-authority';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { Tick } from '../icons';
import type {
  ICheckboxIndicatorProps,
  ICheckboxProps,
  ICheckboxRootProps,
} from './ICheckboxProps';

export const checkboxRootVariants = cva(
  'md:h-5 rounded-md md:w-5 h-5 w-5 border-2 border-retail-gray-400 hover:border-retail-gray-300 focus:outline-retail-primary-900 disabled:border-retail-gray-200 data-[state=checked]:border-none data-[state=checked]:focus:outline-retail-primary-900 data-[state=checked]:disabled:border-none flex items-center justify-center  bg-white data-[state=checked]:bg-retail-primary-700 disabled:bg-retail-gray-300',
  {
    variants: {
      intent: {
        error: 'border-retail-red-600 data-[state=checked]:bg-retail-red-600',
      },
    },
  }
);

const CheckboxRoot = forwardRef<HTMLButtonElement, ICheckboxRootProps>(
  (props, forwardedRef) => {
    const { className, intent, ...rest } = props;
    return (
      <RadixCheckbox.Root
        className={twMerge(checkboxRootVariants({ intent }), className)}
        ref={forwardedRef}
        {...rest}
      />
    );
  }
);

CheckboxRoot.displayName = 'CheckboxRoot';

const CheckboxIndicator = forwardRef<HTMLSpanElement, ICheckboxIndicatorProps>(
  (props, forwardedRef) => {
    const { className, ...rest } = props;
    return (
      <RadixCheckbox.CheckboxIndicator
        className={twMerge('overflow-hidden', className)}
        ref={forwardedRef}
        {...rest}
      />
    );
  }
);

const Checkbox = (props: ICheckboxProps) => {
  const { intent, ...rest } = props;
  return (
    <CheckboxRoot intent={intent} {...rest}>
      <CheckboxIndicator>
        <Tick />
      </CheckboxIndicator>
    </CheckboxRoot>
  );
};

CheckboxIndicator.displayName = 'CheckboxIndicator';

export default Checkbox;
export { CheckboxIndicator, CheckboxRoot };
